import { language } from './features/language';
import { IDLE_MS, resetHistory, setLanguage, state } from './state';
import { stopRecognition } from './speech';
import { hideModal } from './ui/modal';
import { renderHome } from './ui/home';

/**
 * Devuelve la tablet al estado inicial entre pasajeros: borra la conversación,
 * vuelve a español y olvida que se aceptó el aviso de IA.
 */
export function kioskReset(openLanguage = true): void {
  hideModal();
  resetHistory();
  stopRecognition();
  try { speechSynthesis.cancel(); } catch { /* sin sintesis */ }

  setLanguage('es');
  localStorage.removeItem('t2alang');
  state.aiNoticeSeen = false;
  state.sessionTracked = false;
  state.pendingAfterNotice = null;
  renderHome();
  state.lastTouch = Date.now();
  state.idleResetDone = true;

  if (openLanguage) setTimeout(() => language(true), 350);
}

export function initKiosk(): void {
  for (const event of ['pointerdown', 'keydown', 'touchstart'] as const) {
    document.addEventListener(event, () => {
      state.lastTouch = Date.now();
      state.idleResetDone = false;
    }, true);
  }

  setInterval(() => {
    if (Date.now() - state.lastTouch <= IDLE_MS || state.idleResetDone) return;
    kioskReset(true);
  }, 15_000);
}
